import React, { FC } from 'react';

import { RouteItemType } from '~/core/router';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import { useGrowthbookFeatureValue } from '~/hooks/useGrowthbookFeatureValue';
import {
  getOnboardingTitle,
  OnboardingPath,
} from '~/modules/onboarding-new/constants';
import { GB_FEATURE_KEYS, GB_FEATURES } from '~/services/abTests/features';

const LegacyOnboarding = lazyComponentLoader(
  () => import('~/modules/onboarding-new/components/Index'),
);
const NewOnboarding = lazyComponentLoader(
  () => import('~/modules/onboarding-flow/components/Index'),
);

export const JUSTDONE_ONBOARDING_FLOW_VARIANTS =
  GB_FEATURES[GB_FEATURE_KEYS.JUSTDONE_ONBOARDING_FLOW].variants;

export const JustdoneOnboardingExperiment: FC = () => {
  const variant = useGrowthbookFeatureValue(
    GB_FEATURE_KEYS.JUSTDONE_ONBOARDING_FLOW,
  );

  return variant === JUSTDONE_ONBOARDING_FLOW_VARIANTS.test ? (
    <NewOnboarding />
  ) : (
    <LegacyOnboarding />
  );
};

export const JustdoneOnboardingExperimentRoute: RouteItemType = {
  Component: JustdoneOnboardingExperiment,
  path: OnboardingPath,
  getTitle: getOnboardingTitle,
};
